import styles from "./link.module.scss";

const Link = ({ item }) => {
  const localValue = item.Value || item;

  return (<a href={localValue} target='_blank' className={styles.link}>{localValue}</a>)
}

export default Link
